import _ from "@/boot/lodash";
import type { Route } from "vue-router";
import { QUERY_PARAMS } from "../constants";

export function getProductRoute(
  { isAdmin, $route }: { isAdmin: boolean; $route: Route },
  query = {}
) {
  return {
    name: isAdmin ? "adminOrderProductView" : "orderProductViewStep",
    query: {
      ..._.omit($route.query, [QUERY_PARAMS.BASKET_PRODUCT_ID]),
      ...query
    }
  };
}

export function getCategoryRoute(
  { isAdmin, $route }: { isAdmin: boolean; $route: Route },
  query = {}
) {
  return {
    name: isAdmin ? "adminOrderShop" : "orderShopStep",
    query: {
      ..._.omit($route.query, [QUERY_PARAMS.BASKET_PRODUCT_ID]),
      ...query
    }
  };
}
